import { GeoLocationHelper } from '@/helpers/geolocation.helper';
import { PropertyHelper } from '@/helpers/property.helper';
import { UserHelper } from '@/helpers/user.helper';
import { AlertService } from '@/services/alert.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroupDirective, NgForm, UntypedFormBuilder, UntypedFormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { MatExpansionPanel, MatExpansionModule } from '@angular/material/expansion';
import { PropertiesService, RealProperty, RealPropertySummaryLocation } from '@eemo/api-client';
import { DeviceDetectorService } from 'ngx-device-detector';
import { InputComponent } from '../../../../components/ui-forms/input/input.component';
import { MatIconModule } from '@angular/material/icon';
import { TooltipDirective } from '../../../../directives/tooltip/tooltip.directive';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgIf } from '@angular/common';

/** Error when invalid control is dirty, touched, or submitted. */
export class CustomErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

export interface AddressFoundBySearch {
  data: any;
  searched: string;
}

@Component({
    selector: 'app-search-map',
    templateUrl: './search-map.component.html',
    styleUrls: ['./search-map.component.scss'],
    standalone: true,
    imports: [NgIf, MatExpansionModule, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatButtonModule, TooltipDirective, MatIconModule, InputComponent]
})
export class SearchMapComponent {

  @Input() searchEnabled = false;
  @Output() addressFound = new EventEmitter<AddressFoundBySearch>();
  @Output() propertyFound = new EventEmitter<RealProperty>();
  @ViewChild('search') searchPanel: MatExpansionPanel;

  matcher = new CustomErrorStateMatcher();
  searchOwnerFormControl = new UntypedFormControl('', [Validators.minLength(2)]);
  searchEemoIdFormControl = new UntypedFormControl('', [Validators.minLength(4)]);

  get form_searchTerm() {
    return this.searchForm.get('term') as FormControl<string>;
  }

  searchForm = this.fb.group({
    term: [null, Validators.minLength(2)],
  });

  constructor(
    private alertService: AlertService,
    private propService: PropertiesService,
    private geoLocationHelper: GeoLocationHelper,
    private deviceService: DeviceDetectorService,
    public propertyHelper: PropertyHelper,
    private userHelper: UserHelper,
    private fb: UntypedFormBuilder,
  ) {
  }

  doSearchAddress(search: string) {
    if (search) {
      this.geoLocationHelper.findLocationFromAddress(search).subscribe(
        (data) => {
          if (data[0]) {
            this.searchActionDone();
            this.addressFound.emit({data: data, searched: search});
          } else {
            this.alertService.warning("Aucune correspondance n'a été trouvée. Veuillez vérifier votre adresse.");
          }
        },
        (err: HttpErrorResponse) => {
          this.alertService.apiBadRequest(err, "Erreur de l'API OpenStreetMap");
        }
      );
    }
  }

  searchActionDone() {
    if (!this.deviceService.isDesktop()) {
      this.searchPanel.close();
    }
  }

  onPropertyFound(prop: RealProperty) {
    this.searchActionDone();
    this.propertyFound.emit(prop);
  }
}
